import { makeAutoObservable, runInAction } from 'mobx';
import { ResumeApi } from '../../apis/Resume';
import { Resume, ResumeFilter } from '../../models/Resume';

export class ResumeManagementPageModel {
    resumes: Resume[] = [];
    loading = false;
    filter: ResumeFilter = {};
    selectedResume: Resume | null = null;
    detailModalVisible = false;

    constructor() {
        makeAutoObservable(this);
    }

    async loadResumes() {
        this.loading = true;
        try {
            const data = await ResumeApi.queryByConditions(this.filter);
            this.resumes = data;
        } catch (error) {
            console.error('加载简历列表失败:', error);
        } finally {
            this.loading = false;
        }
    }

    async loadResumeDetail(id: string) {
        try {
            const data = await ResumeApi.getResumeDetail(id);
            this.selectedResume = data;
            this.detailModalVisible = true;
        } catch (error) {
            console.error('加载简历详情失败:', error);
        }
    }

    setFilter(filter: Partial<ResumeFilter>) {
        this.filter = { ...this.filter, ...filter };
    }

    resetFilter() {
        this.filter = {};
    }

    setDetailModalVisible(visible: boolean) {
        this.detailModalVisible = visible;
        if (!visible) {
            this.selectedResume = null;
        }
    }

    async updateResumeStatus(id: string, isServing: boolean) {
        try {
            await ResumeApi.updateResumeStatus(id, isServing);
            // 创建全新的数组
            this.resumes = [...this.resumes.map(resume => 
                resume.id === id ? { ...resume, isServing } : resume
            )];
        } catch (error) {
            console.error('更新简历状态失败:', error);
        }
    }

    async deleteResume(id: string) {
        try {
            await ResumeApi.deleteResume(id);
            // 从本地列表中移除
            this.resumes = this.resumes.filter(r => r.id !== id);
        } catch (error) {
            console.error('删除简历失败:', error);
        }
    }
} 